import { apiClient } from './api';

export interface DataFlow {
  id: string;
  tenantId: string;
  type: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  source: string;
  target: string;
  timestamp: string;
  duration?: number;
  errorMessage?: string;
}

export interface DataFlowFilters {
  type?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  pageSize?: number;
}

class DataFlowService {
  async getDataFlows(filters: DataFlowFilters = {}): Promise<DataFlow[]> {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.pageSize) params.append('pageSize', filters.pageSize.toString());

    return await apiClient.get<DataFlow[]>(`/dataflows?${params.toString()}`);
  }

  async getDataFlow(id: string): Promise<DataFlow> {
    return await apiClient.get<DataFlow>(`/dataflows/${id}`);
  }

  async exportDataFlows(filters: DataFlowFilters, format: 'csv' | 'excel'): Promise<Blob> {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    params.append('format', format);

    return await apiClient.get<Blob>(`/dataflows/export?${params.toString()}`);
  }
}

export const dataFlowService = new DataFlowService();
